var React = require('react');

function IcoArrowDownInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("g",{"key":1},React.createElement("path",{"className":"st0","d":"M27.95,31.95L52.77,6.5c0.38-0.39,0.38-1.02-0.01-1.41L49.9,2.22c-0.19-0.19-0.45-0.29-0.71-0.29\n\t\tc-0.27,0-0.52,0.11-0.71,0.3L27.23,24.08L5.99,2.23c-0.19-0.19-0.44-0.3-0.71-0.3c-0.27,0-0.52,0.1-0.71,0.29L1.7,5.09\n\t\tC1.5,5.29,1.4,5.54,1.4,5.8c0,0.25,0.09,0.5,0.28,0.7l24.83,25.46c0.19,0.19,0.45,0.3,0.72,0.3S27.76,32.14,27.95,31.95z"}))]);
}

IcoArrowDownInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 54.46 34.18","style":{"enableBackground":"new 0 0 54.46 34.18"},"xmlSpace":"preserve"};

module.exports = IcoArrowDownInline;

IcoArrowDownInline.default = IcoArrowDownInline;
